function custom_indicators_getter(PineJS) {
  return Promise.resolve([
    {
      name: "overflowdelta",
      metainfo: {
        _metainfoVersion: 51,
        id: "overflowdelta@tv-basicstudies-1",
        description: "FT Orderflow Delta",
        shortDescription: "FT Orderflow Delta",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "First color",
              },
              1: {
                name: "Second color",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "tomato",
                  width: 5,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "green",
                  width: 5,
                  style: 0,
                },
              },
            },
          },
          styles: {},
          precision: 4,
          inputs: {},
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 5,
              plottype: 5, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#0000FF",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Orderflow Delta",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#d";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "cummulativedelta",
      metainfo: {
        _metainfoVersion: 51,
        id: "cummulativedelta@tv-basicstudies-1",
        description: "FT Orderflow Cumulative Delta",
        shortDescription: "FT Orderflow Cumulative Delta",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "First color",
              },
              1: {
                name: "Second color",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "tomato",
                  width: 5,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "green",
                  width: 5,
                  style: 0,
                },
              },
            },
          },
          styles: {},
          precision: 4,
          inputs: {},
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 5,
              plottype: 5, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#0000FF",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Orderflow Delta",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#cd";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "openInt",
      metainfo:  {
        name: "openInt",
        _metainfoVersion: 51,
        id: "openInt@tv-basicstudies-1",
        description: "FT Open Interest",
        shortDescription: "FT Open Interest",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 1,
        },
        plots: [
          { id: "plot_0", type: "line", },
         
        ],
       
        defaults: {
         
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 8, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#ffcb7f",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Open Interest",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#oi";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "FTDelivery",
      metainfo: {
        name: "FTDelivery",

        _metainfoVersion: 51,
        id: "FTDelivery@tv-basicstudies-1",
        description: "FT Delivery",
        shortDescription: "FT Delivery",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "volume",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "First color",
              },
              1: {
                name: "Second color",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "#0000ff",
                  width: 5,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "#0000ff",
                  width: 5,
                  style: 0,
                },
              },
            },
          },
          styles: {},
          precision: 4,
          inputs: {},
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 5,
              plottype: 5, // display as line

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#0000FF",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Delivery",
            histogramBase: 0,
          },
        },
        inputs: [{
          id: "length",
          name: "Length",
          defval: 9,
          type: "integer",
          min: 1,
          max: 10000,
      },],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#del";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          //const del = getPatternData()[context.symbol.time]?.delivery;
           return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "FTcumoiINT",
      metainfo: {
        _metainfoVersion: 51,
        id: "FTcumoiINT@tv-basicstudies-1",
        description: "FT Cumoi Interest",
        shortDescription: "FT Cumoi Interest",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "volume",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "First color",
              },
              1: {
                name: "Second color",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "#ffa500",
                  width: 5,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "#ffa500",
                  width: 5,
                  style: 0,
                },
              },
            },
          },
          styles: {},
          precision: 4,
          inputs: {},
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 5,
              plottype: 5, // display as line

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#0000FF",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Cumoi Interest",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTcumoiINT";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
        
        
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "FT Orderflow Delta Bars",
      metainfo: {
        _metainfoVersion: 51,

        id: "deltabars@tv-basicstudies-1",
        name: "FT Orderflow Delta Bars",
        description: "FT Orderflow Delta Bars",
        shortDescription: "FT Orderflow Delta Bars",

        isCustomIndicator: true,
        isTVScript: false,
        isTVScriptStub: false,

        is_price_study: false, // whether the study should appear on the main series pane.
        linkedToSeries: true, // whether the study price scale should be the same as the main series one.

        format: {
          type: "price",
          precision: 2,
        },

        plots: [
          {
            id: "plot_open",
            type: "ohlc_open",
            target: "plot_candle",
          },
          {
            id: "plot_high",
            type: "ohlc_high",
            target: "plot_candle",
          },
          {
            id: "plot_low",
            type: "ohlc_low",
            target: "plot_candle",
          },
          {
            id: "plot_close",
            type: "ohlc_close",
            target: "plot_candle",
          },
          {
            id: "plot_bar_color",
            type: "ohlc_colorer",
            palette: "palette_bar",
            target: "plot_candle",
          },
          {
            id: "plot_wick_color",
            type: "wick_colorer",
            palette: "palette_wick",
            target: "plot_candle",
          },
        ],

        palettes: {
          palette_bar: {
            colors: [{ name: "Colour One" }, { name: "Colour Two" }],

            valToIndex: {
              0: 0,
              1: 1,
            },
          },
          palette_wick: {
            colors: [{ name: "Colour One" }, { name: "Colour Two" }],

            valToIndex: {
              0: 0,
              1: 1,
            },
          },
        },

        ohlcPlots: {
          plot_candle: {
            title: "Candles",
          },
        },

        defaults: {
          ohlcPlots: {
            plot_candle: {
              borderColor: "#000000",
              color: "#000000",
              drawBorder: false,
              drawWick: true,
              plottype: "ohlc_candles",
              visible: true,
              wickColor: "#000000",
            },
          },

          palettes: {
            palette_bar: {
              colors: [
                { color: "tomato", width: 1, style: 0 },
                { color: "green", width: 1, style: 0 },
              ],
            },
            palette_wick: {
              colors: [{ color: "tomato" }, { color: "green" }],
            },
          },

          precision: 2,
          inputs: {},
        },
        styles: {},
        inputs: [],
      },
      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#deltabars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const o = PineJS.Std.open(this._context);
          const h = PineJS.Std.high(this._context);
          const l = PineJS.Std.low(this._context);
          const c = PineJS.Std.close(this._context);

          const colour = c > o ? 1 : 0;

          return [
            o,
            h,
            l,
            c,
            colour /*bar*/,
            colour /*wick*/,
            colour /*border*/,
          ];
        };
      },
    },
    // {
    //   name: "FT Greeks - Delta",
    //   metainfo: {
    //     _metainfoVersion: 51,

    //     id: "FTGreeksDeltaBars@tv-basicstudies-1",
    //     name: "FT Greeks - Delta",
    //     description: "FT Greeks - Delta",
    //     shortDescription: "FT Greeks - Delta",

    //     isCustomIndicator: true,
    //     isTVScript: false,
    //     isTVScriptStub: false,

    //     is_price_study: false, // whether the study should appear on the main series pane.
    //     linkedToSeries: true, // whether the study price scale should be the same as the main series one.

    //     format: {
    //       type: "price",
    //       precision: 4,
    //     },

    //     plots: [
    //       {
    //         id: "plot_open",
    //         type: "ohlc_open",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_high",
    //         type: "ohlc_high",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_low",
    //         type: "ohlc_low",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_close",
    //         type: "ohlc_close",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_bar_color",
    //         type: "ohlc_colorer",
    //         palette: "palette_bar",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_wick_color",
    //         type: "wick_colorer",
    //         palette: "palette_wick",
    //         target: "plot_candle",
    //       },
    //     ],

    //     palettes: {
    //       palette_bar: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //       palette_wick: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //     },

    //     ohlcPlots: {
    //       plot_candle: {
    //         title: "Candles",
    //       },
    //     },

    //     defaults: {
    //       ohlcPlots: {
    //         plot_candle: {
    //           borderColor: "#000000",
    //           color: "#000000",
    //           drawBorder: false,
    //           drawWick: true,
    //           plottype: "ohlc_candles",
    //           visible: true,
    //           wickColor: "#000000",
    //         },
    //       },

    //       palettes: {
    //         palette_bar: {
    //           colors: [
    //             { color: "tomato", width: 1, style: 0 },
    //             { color: "green", width: 1, style: 0 },
    //           ],
    //         },
    //         palette_wick: {
    //           colors: [{ color: "tomato" }, { color: "green" }],
    //         },
    //       },

    //       precision: 2,
    //       inputs: {},
    //     },
    //     styles: {},
    //     inputs: [],
    //   },
    //   constructor: function () {
    //     this.init = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksDeltaBars";

    //       this._context.new_sym(
    //         symbol,
    //         PineJS.Std.period(this._context),
    //         PineJS.Std.period(this._context)
    //       );
    //     };

    //     this.main = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       this._context.select_sym(1);

    //       const o = PineJS.Std.open(this._context);
    //       const h = PineJS.Std.high(this._context);
    //       const l = PineJS.Std.low(this._context);
    //       const c = PineJS.Std.close(this._context);

    //       const colour = c > o ? 1 : 0;
    //       return [
    //       c
    //     };
    //   },
    // },
    {
      name: "FT Greeks - Delta",
      metainfo:  {
        _metainfoVersion: 51,
        id: "FTGreeksDeltaBars@tv-basicstudies-1",
        description: "FT Greeks - Delta",
        shortDescription: "FT Greeks - Delta",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line", },
         
        ],
       
        defaults: {
         
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 8, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#ffcb7f",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Greeks - Delta",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksDeltaBars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    {
      name: "FT Greeks - Theta",
      metainfo:  {
        _metainfoVersion: 51,
        id: "FTGreeksThetaBars@tv-basicstudies-1",
        description: "FT Greeks - Theta",
        shortDescription: "FT Greeks - Theta",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line", },
         
        ],
       
        defaults: {
         
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 8, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#ffcb7f",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Greeks - Theta",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksThetaBars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    // {
    //   name: "FT Greeks - Theta",
    //   metainfo: {
    //     _metainfoVersion: 51,

    //     id: "FTGreeksThetaBars@tv-basicstudies-1",
    //     name: "FT Greeks - Theta",
    //     description: "FT Greeks - Theta",
    //     shortDescription: "FT Greeks - Theta",

    //     isCustomIndicator: true,
    //     isTVScript: false,
    //     isTVScriptStub: false,

    //     is_price_study: false, // whether the study should appear on the main series pane.
    //     linkedToSeries: true, // whether the study price scale should be the same as the main series one.

    //     format: {
    //       type: "price",
    //       precision: 2,
    //     },

    //     plots: [
    //       {
    //         id: "plot_open",
    //         type: "ohlc_open",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_high",
    //         type: "ohlc_high",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_low",
    //         type: "ohlc_low",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_close",
    //         type: "ohlc_close",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_bar_color",
    //         type: "ohlc_colorer",
    //         palette: "palette_bar",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_wick_color",
    //         type: "wick_colorer",
    //         palette: "palette_wick",
    //         target: "plot_candle",
    //       },
    //     ],

    //     palettes: {
    //       palette_bar: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //       palette_wick: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //     },

    //     ohlcPlots: {
    //       plot_candle: {
    //         title: "Candles",
    //       },
    //     },

    //     defaults: {
    //       ohlcPlots: {
    //         plot_candle: {
    //           borderColor: "#000000",
    //           color: "#000000",
    //           drawBorder: false,
    //           drawWick: true,
    //           plottype: "ohlc_candles",
    //           visible: true,
    //           wickColor: "#000000",
    //         },
    //       },

    //       palettes: {
    //         palette_bar: {
    //           colors: [
    //             { color: "tomato", width: 1, style: 0 },
    //             { color: "green", width: 1, style: 0 },
    //           ],
    //         },
    //         palette_wick: {
    //           colors: [{ color: "tomato" }, { color: "green" }],
    //         },
    //       },

    //       precision: 2,
    //       inputs: {},
    //     },
    //     styles: {},
    //     inputs: [],
    //   },
    //   constructor: function () {
    //     this.init = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksThetaBars";

    //       this._context.new_sym(
    //         symbol,
    //         PineJS.Std.period(this._context),
    //         PineJS.Std.period(this._context)
    //       );
    //     };

    //     this.main = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       this._context.select_sym(1);

    //       const o = PineJS.Std.open(this._context);
    //       const h = PineJS.Std.high(this._context);
    //       const l = PineJS.Std.low(this._context);
    //       const c = PineJS.Std.close(this._context);

    //       const colour = c > o ? 1 : 0;
    //       return [
    //         o,
    //         h,
    //         l,
    //         c,
    //         colour /*bar*/,
    //         colour /*wick*/,
    //         colour /*border*/,
    //       ];
    //     };
    //   },
    // },
    {
      name: "FT Greeks - Vega",
      metainfo:  {
        _metainfoVersion: 51,
        id: "FTGreeksVegaBars@tv-basicstudies-1",
        description: "FT Greeks - Vega",
        shortDescription: "FT Greeks - Vega",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line", },
         
        ],
       
        defaults: {
         
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 8, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#ffcb7f",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Greeks - Vega",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksVegaBars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    // {
    //   name: "FT Greeks - Vega",
    //   metainfo: {
    //     _metainfoVersion: 51,

    //     id: "FTGreeksVegaBars@tv-basicstudies-1",
    //     name: "FT Greeks - Vega",
    //     description: "FT Greeks - Vega",
    //     shortDescription: "FT Greeks - Vega",

    //     isCustomIndicator: true,
    //     isTVScript: false,
    //     isTVScriptStub: false,

    //     is_price_study: false, // whether the study should appear on the main series pane.
    //     linkedToSeries: true, // whether the study price scale should be the same as the main series one.

    //     format: {
    //       type: "price",
    //       precision: 2,
    //     },

    //     plots: [
    //       {
    //         id: "plot_open",
    //         type: "ohlc_open",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_high",
    //         type: "ohlc_high",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_low",
    //         type: "ohlc_low",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_close",
    //         type: "ohlc_close",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_bar_color",
    //         type: "ohlc_colorer",
    //         palette: "palette_bar",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_wick_color",
    //         type: "wick_colorer",
    //         palette: "palette_wick",
    //         target: "plot_candle",
    //       },
    //     ],

    //     palettes: {
    //       palette_bar: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //       palette_wick: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //     },

    //     ohlcPlots: {
    //       plot_candle: {
    //         title: "Candles",
    //       },
    //     },

    //     defaults: {
    //       ohlcPlots: {
    //         plot_candle: {
    //           borderColor: "#000000",
    //           color: "#000000",
    //           drawBorder: false,
    //           drawWick: true,
    //           plottype: "ohlc_candles",
    //           visible: true,
    //           wickColor: "#000000",
    //         },
    //       },

    //       palettes: {
    //         palette_bar: {
    //           colors: [
    //             { color: "tomato", width: 1, style: 0 },
    //             { color: "green", width: 1, style: 0 },
    //           ],
    //         },
    //         palette_wick: {
    //           colors: [{ color: "tomato" }, { color: "green" }],
    //         },
    //       },

    //       precision: 2,
    //       inputs: {},
    //     },
    //     styles: {},
    //     inputs: [],
    //   },
    //   constructor: function () {
    //     this.init = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksVegaBars";

    //       this._context.new_sym(
    //         symbol,
    //         PineJS.Std.period(this._context),
    //         PineJS.Std.period(this._context)
    //       );
    //     };

    //     this.main = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       this._context.select_sym(1);

    //       const o = PineJS.Std.open(this._context);
    //       const h = PineJS.Std.high(this._context);
    //       const l = PineJS.Std.low(this._context);
    //       const c = PineJS.Std.close(this._context);

    //       const colour = c > o ? 1 : 0;
    //       return [
    //         o,
    //         h,
    //         l,
    //         c,
    //         colour /*bar*/,
    //         colour /*wick*/,
    //         colour /*border*/,
    //       ];
    //     };
    //   },
    // },

    {
      name: "FT Greeks - Gamma",
      metainfo:  {
        _metainfoVersion: 51,
        id: "FTGreeksGammaBars@tv-basicstudies-1",
        description: "FT Greeks - Gamma",
        shortDescription: "FT Greeks - Gamma",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "price",
          precision: 2,
        },
        plots: [
          { id: "plot_0", type: "line", },
         
        ],
       
        defaults: {
         
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 8, // display as columns

              // Show price line?
              trackPrice: false,

              // Plot color
              color: "#ffcb7f",
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "FT Greeks - Gamma",
            histogramBase: 0,
          },
        },
        inputs: [],
      },

      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksGammaBars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const v = PineJS.Std.close(this._context);
          return [v, v > 0 ? 1 : 0];
        };
      },
    },
    // {
    //   name: "FT Greeks - Gamma",
    //   metainfo: {
    //     _metainfoVersion: 51,

    //     id: "FTGreeksGammaBars@tv-basicstudies-1",
    //     name: "FT Greeks - Gamma",
    //     description: "FT Greeks - Gamma",
    //     shortDescription: "FT Greeks - Gamma",

    //     isCustomIndicator: true,
    //     isTVScript: false,
    //     isTVScriptStub: false,

    //     is_price_study: false, // whether the study should appear on the main series pane.
    //     linkedToSeries: true, // whether the study price scale should be the same as the main series one.

    //     format: {
    //       type: "price",
    //       precision: 4,
    //     },

    //     plots: [
    //       {
    //         id: "plot_open",
    //         type: "ohlc_open",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_high",
    //         type: "ohlc_high",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_low",
    //         type: "ohlc_low",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_close",
    //         type: "ohlc_close",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_bar_color",
    //         type: "ohlc_colorer",
    //         palette: "palette_bar",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_wick_color",
    //         type: "wick_colorer",
    //         palette: "palette_wick",
    //         target: "plot_candle",
    //       },
    //     ],

    //     palettes: {
    //       palette_bar: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //       palette_wick: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //     },

    //     ohlcPlots: {
    //       plot_candle: {
    //         title: "Candles",
    //       },
    //     },

    //     defaults: {
    //       ohlcPlots: {
    //         plot_candle: {
    //           borderColor: "#000000",
    //           color: "#000000",
    //           drawBorder: false,
    //           drawWick: true,
    //           plottype: "ohlc_candles",
    //           visible: true,
    //           wickColor: "#000000",
    //         },
    //       },

    //       palettes: {
    //         palette_bar: {
    //           colors: [
    //             { color: "tomato", width: 1, style: 0 },
    //             { color: "green", width: 1, style: 0 },
    //           ],
    //         },
    //         palette_wick: {
    //           colors: [{ color: "tomato" }, { color: "green" }],
    //         },
    //       },

    //       precision: 2,
    //       inputs: {},
    //     },
    //     styles: {},
    //     inputs: [],
    //   },
    //   constructor: function () {
    //     this.init = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       const symbol = PineJS.Std.ticker(this._context) + "#FTGreeksGammaBars";

    //       this._context.new_sym(
    //         symbol,
    //         PineJS.Std.period(this._context),
    //         PineJS.Std.period(this._context)
    //       );
    //     };

    //     this.main = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       this._context.select_sym(1);

    //       const o = PineJS.Std.open(this._context);
    //       const h = PineJS.Std.high(this._context);
    //       const l = PineJS.Std.low(this._context);
    //       const c = PineJS.Std.close(this._context);
    //       const colour = Math.round(Math.random());

    //       return [
    //         o,
    //         h,
    //         l,
    //         c,
    //         colour /*bar*/,
    //         colour /*wick*/,
    //         colour /*border*/,
    //       ];
    //     };
    //   },
    // },
    {
      name: "FT Impl Vol (IV)",
      metainfo: {
        _metainfoVersion: 51,

        id: "FTIVBars@tv-basicstudies-1",
        name: "FT Impl Vol (IV)",
        description: "FT Impl Vol (IV)",
        shortDescription: "FT Impl Vol (IV)",

        isCustomIndicator: true,
        isTVScript: false,
        isTVScriptStub: false,

        is_price_study: false, // whether the study should appear on the main series pane.
        linkedToSeries: true, // whether the study price scale should be the same as the main series one.

        format: {
          type: "price",
          precision: 2,
        },

        plots: [
          {
            id: "plot_open",
            type: "ohlc_open",
            target: "plot_candle",
          },
          {
            id: "plot_high",
            type: "ohlc_high",
            target: "plot_candle",
          },
          {
            id: "plot_low",
            type: "ohlc_low",
            target: "plot_candle",
          },
          {
            id: "plot_close",
            type: "ohlc_close",
            target: "plot_candle",
          },
          {
            id: "plot_bar_color",
            type: "ohlc_colorer",
            palette: "palette_bar",
            target: "plot_candle",
          },
          {
            id: "plot_wick_color",
            type: "wick_colorer",
            palette: "palette_wick",
            target: "plot_candle",
          },
        ],

        palettes: {
          palette_bar: {
            colors: [{ name: "Colour One" }, { name: "Colour Two" }],

            valToIndex: {
              0: 0,
              1: 1,
            },
          },
          palette_wick: {
            colors: [{ name: "Colour One" }, { name: "Colour Two" }],

            valToIndex: {
              0: 0,
              1: 1,
            },
          },
        },

        ohlcPlots: {
          plot_candle: {
            title: "Candles",
          },
        },

        defaults: {
          ohlcPlots: {
            plot_candle: {
              borderColor: "#000000",
              color: "#000000",
              drawBorder: false,
              drawWick: true,
              plottype: "ohlc_candles",
              visible: true,
              wickColor: "#000000",
            },
          },

          palettes: {
            palette_bar: {
              colors: [
                { color: "#ef5350", width: 1, style: 0 },
                { color: "#26a69a", width: 1, style: 0 },
              ],
            },
            palette_wick: {
              colors: [{ color: "#ef5350" }, { color: "#26a69a" }],
            },
          },

          precision: 2,
          inputs: {},
        },
        styles: {},
        inputs: [],
      },
      constructor: function () {
        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          const symbol = PineJS.Std.ticker(this._context) + "#FTIVBars";

          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context)
          );
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);

          const o = PineJS.Std.open(this._context);
          const h = PineJS.Std.high(this._context);
          const l = PineJS.Std.low(this._context);
          const c = PineJS.Std.close(this._context);
        //  const colour = Math.round(Math.random());
          const colour = c > o ? 1 : 0;
          return [
            o,
            h,
            l,
            c,
            colour /*bar*/,
            colour /*wick*/,
            colour /*border*/,
          ];
        };
      },
    },
    // {
    //   name: "FT Volume",
    //   metainfo: {
    //     _metainfoVersion: 51,

    //     id: "ftVolume@tv-basicstudies-1",
    //     name: "FT Volume",
    //     description: "FT Volume",
    //     shortDescription: "FT Volume",

    //     isCustomIndicator: true,
    //     isTVScript: false,
    //     isTVScriptStub: false,

    //     is_price_study: false, // whether the study should appear on the main series pane.
    //     linkedToSeries: true, // whether the study price scale should be the same as the main series one.

    //     format: {
    //       type: "price",
    //       precision: 2,
    //     },

    //     plots: [
    //       {
    //         id: "plot_open",
    //         type: "ohlc_open",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_high",
    //         type: "ohlc_high",
    //         target: "plot_candle",
    //       },
    //       // {
    //       //   id: "plot_low",
    //       //   type: "ohlc_low",
    //       //   target: "plot_candle",
    //       // },
    //       // {
    //       //   id: "plot_close",
    //       //   type: "ohlc_close",
    //       //   target: "plot_candle",
    //       // },
    //       {
    //         id: "plot_bar_color",
    //         type: "ohlc_colorer",
    //         palette: "palette_bar",
    //         target: "plot_candle",
    //       },
    //       {
    //         id: "plot_wick_color",
    //         type: "wick_colorer",
    //         palette: "palette_wick",
    //         target: "plot_candle",
    //       },
    //     ],

    //     palettes: {
    //       palette_bar: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //       palette_wick: {
    //         colors: [{ name: "Colour One" }, { name: "Colour Two" }],

    //         valToIndex: {
    //           0: 0,
    //           1: 1,
    //         },
    //       },
    //     },

    //     ohlcPlots: {
    //       plot_candle: {
    //         title: "Candles",
    //       },
    //     },

    //     defaults: {
    //       ohlcPlots: {
    //         plot_candle: {
    //           borderColor: "#000000",
    //           color: "#000000",
    //           drawBorder: false,
    //           drawWick: true,
    //           plottype: "ohlc_candles",
    //           visible: true,
    //           wickColor: "#000000",
    //         },
    //       },

    //       palettes: {
    //         palette_bar: {
    //           colors: [
    //             { color: "tomato", width: 1, style: 0 },
    //             { color: "green", width: 1, style: 0 },
    //           ],
    //         },
    //         palette_wick: {
    //           colors: [{ color: "tomato" }, { color: "green" }],
    //         },
    //       },

    //       precision: 2,
    //       inputs: {},
    //     },
    //     styles: {},
    //     inputs: [],
    //   },
    //   constructor: function () {
    //     this.init = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       const symbol = PineJS.Std.ticker(this._context) + "#ftVolume";

    //       this._context.new_sym(
    //         symbol,
    //         PineJS.Std.period(this._context),
    //         PineJS.Std.period(this._context)
    //       );
    //     };

    //     this.main = function (context, inputCallback) {
    //       this._context = context;
    //       this._input = inputCallback;
    //       this._context.select_sym(1);

    //       const o = PineJS.Std.open(this._context);
    //       const h = PineJS.Std.high(this._context);
    //       const l = PineJS.Std.low(this._context);
    //       const c = PineJS.Std.close(this._context);
    //       const colour = Math.round(Math.random());

    //       return [
    //         o,
    //         h,
    //         0,
    //         0,
    //         colour /*bar*/,
    //         colour /*wick*/,
    //         colour /*border*/,
    //       ];
    //     };
    //   },
    // },
    {
      name: "Volume with 50 MA",
      metainfo: {
        _metainfoVersion: 51,
        id: "volume50ma@tv-basicstudies-1",
        name: "Volume with 50 MA",
        description: "Volume with 50 MA - Black below MA, candle color above MA, blue for pocket pivot",
        shortDescription: "Volume 50 MA",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "volume",
          precision: 0,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
          { id: "plot_2", type: "line" },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "Black (below MA)",
              },
              1: {
                name: "Red (down candle)",
              },
              2: {
                name: "Green (up candle)",
              },
              3: {
                name: "Blue (pocket pivot)",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "#000000",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "#ef5350",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                2: {
                  color: "#26a69a",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                3: {
                  color: "#26a69a",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
              },
            },
          },
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 3,
              plottype: 5, // display as columns (histogram)
              trackPrice: false,
              color: "#0000FF",
            },
            plot_2: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 0, // display as line
              trackPrice: false,
              color: "#FFA500",
            },
          },
          precision: 0,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: "Volume",
            histogramBase: 0,
          },
          plot_2: {
            title: "50 MA",
          },
        },
        inputs: [],
      },

      constructor: function () {
        const MA_LENGTH = 50;
        const POCKET_PIVOT_LOOKBACK = 10;
        
        if (!this.volumeHistory) {
          this.volumeHistory = [];
        }
        if (!this.closeHistory) {
          this.closeHistory = [];
        }
        if (!this.sessionVolumes) {
          this.sessionVolumes = [];
        }
        if (!this.currentSessionDate) {
          this.currentSessionDate = null;
        }

        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;

          const volume = PineJS.Std.volume(this._context) || 0;
          const close = PineJS.Std.close(this._context);
          const open = PineJS.Std.open(this._context);
          const high = PineJS.Std.high(this._context);
          const low = PineJS.Std.low(this._context);
          const prevClose = PineJS.Std.close(this._context, 1);
          const time = PineJS.Std.time(this._context);

          if (!this.volumeHistory) {
            this.volumeHistory = [];
          }
          if (!this.closeHistory) {
            this.closeHistory = [];
          }
          if (!this.sessionVolumes) {
            this.sessionVolumes = [];
          }
          
          this.volumeHistory.push(volume);
          this.closeHistory.push(close);

          if (this.volumeHistory.length > MA_LENGTH) {
            this.volumeHistory.shift();
          }
          if (this.closeHistory.length > POCKET_PIVOT_LOOKBACK + 1) {
            this.closeHistory.shift();
          }

          if (time) {
            const barDate = new Date(time * 1000);
            const sessionDateKey = barDate.toISOString().split('T')[0];
            
            if (this.currentSessionDate !== sessionDateKey) {
              if (this.currentSessionDate !== null && this.currentSessionVolume !== undefined) {
                this.sessionVolumes.push({
                  date: this.currentSessionDate,
                  volume: this.currentSessionVolume
                });
                
                if (this.sessionVolumes.length > POCKET_PIVOT_LOOKBACK + 1) {
                  this.sessionVolumes.shift();
                }
              }
              
              this.currentSessionDate = sessionDateKey;
              this.currentSessionVolume = 0;
            }
            
            this.currentSessionVolume = (this.currentSessionVolume || 0) + volume;
          }

          let volumeMA = 0;
          if (this.volumeHistory && this.volumeHistory.length > 0) {
            if (this.volumeHistory.length >= MA_LENGTH) {
              let sum = 0;
              const startIndex = this.volumeHistory.length - MA_LENGTH;
              for (let i = startIndex; i < this.volumeHistory.length; i++) {
                sum += this.volumeHistory[i];
              }
              volumeMA = sum / MA_LENGTH;
            } else {
              let sum = 0;
              for (let i = 0; i < this.volumeHistory.length; i++) {
                sum += this.volumeHistory[i];
              }
              volumeMA = sum / this.volumeHistory.length;
            }
          }

            let isPocketPivot = false;
            
          const currentSessionVolume = this.currentSessionVolume || 0;
            
          if (this.sessionVolumes && this.sessionVolumes.length >= POCKET_PIVOT_LOOKBACK) {
            let maxSessionVolume = null;
              
            for (let i = 0; i < POCKET_PIVOT_LOOKBACK && i < this.sessionVolumes.length; i++) {
              const sessionData = this.sessionVolumes[this.sessionVolumes.length - 1 - i];
              
              if (sessionData && sessionData.volume != null && sessionData.volume !== undefined && !isNaN(sessionData.volume) && sessionData.volume > 0) {
                if (maxSessionVolume === null || sessionData.volume > maxSessionVolume) {
                  maxSessionVolume = sessionData.volume;
                  }
                }
              }
              
            if (maxSessionVolume !== null && currentSessionVolume > maxSessionVolume) {
              isPocketPivot = true;
              }
            }

          let colorIndex = 0;

            if (isPocketPivot) {
            colorIndex = 3;
          } else if (volumeMA > 0 && volume >= volumeMA) {
            colorIndex = close >= open ? 2 : 1;
            } else {
              colorIndex = 0;
          }

          return [volume, colorIndex, volumeMA];
        };
      },
    },
    {
      name: "Simple Volume",
      metainfo: {
        _metainfoVersion: 51,
        id: "volume50ma@tv-basicstudies-1",
        name: "Simple Volume",
        description: "Simple Volume",
        shortDescription: "Simple Volume",
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: "volume",
          precision: 0,
        },
        plots: [
          { id: "plot_0", type: "line" },
          {
            id: "plot_1",
            type: "colorer",
            target: "plot_0",
            palette: "paletteId1",
          },
          { id: "plot_2", type: "line" },
        ],
        palettes: {
          paletteId1: {
            colors: {
              0: {
                name: "Black (below MA)",
              },
              1: {
                name: "Red (down candle)",
              },
              2: {
                name: "Green (up candle)",
              },
              3: {
                name: "Blue (pocket pivot)",
              },
            },
          },
        },
        defaults: {
          palettes: {
            paletteId1: {
              colors: {
                0: {
                  color: "#000000",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                1: {
                  color: "#CC3216",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                2: {
                  color: "#4CB06E",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
                3: {
                  color: "#2196F3",
                  width: 1,
                  style: 0,
                  opacity: 100,
                },
              },
            },
          },
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 3,
              plottype: 5,
              trackPrice: false,
              color: "#0000FF",
            },
            plot_2: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 0,
              trackPrice: false,
              color: "#FFA500",
            },
          },
          precision: 0,
          inputs: {
            ma_period: 50,
            ma_visible: true,
          },
        },
        styles: {
          plot_0: {
            title: "Volume",
            histogramBase: 0,
          },
          plot_2: {
            title: "MA Style",
          },
        },
        inputs: [
          {
            id: "ma_period",
            name: "MA Period",
            defval: 50,
            type: "integer",
            min: 1,
            max: 500,
          },
          {
            id: "ma_visible",
            name: "Show MA Line",
            defval: true,
            type: "bool",
          },
        ],
      },

      constructor: function () {
        const POCKET_PIVOT_LOOKBACK = 10;
        
        if (!this.volumeHistory) {
          this.volumeHistory = [];
        }
        if (!this.closeHistory) {
          this.closeHistory = [];
        }
        if (!this.sessionData) {
          this.sessionData = [];
        }
        if (!this.currentSessionDate) {
          this.currentSessionDate = null;
        }
        if (!this.currentSessionClose) {
          this.currentSessionClose = null;
        }

        this.init = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
        };

        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;

          const maPeriod = this._input(0) !== undefined ? this._input(0) : 50;
          const maVisible = this._input(1) !== undefined ? this._input(1) : true;

          const volume = PineJS.Std.volume(this._context) || 0;
          const close = PineJS.Std.close(this._context);
          const open = PineJS.Std.open(this._context);
          const high = PineJS.Std.high(this._context);
          const low = PineJS.Std.low(this._context);
          const prevClose = PineJS.Std.close(this._context, 1);
          const time = PineJS.Std.time(this._context);

          if (!this.volumeHistory) {
            this.volumeHistory = [];
          }
          if (!this.closeHistory) {
            this.closeHistory = [];
          }
          if (!this.sessionData) {
            this.sessionData = [];
          }
          
          this.volumeHistory.push(volume);
          this.closeHistory.push(close);
          
          const maxHistoryLength = Math.max(maPeriod, 50);
          if (this.volumeHistory.length > maxHistoryLength) {
            this.volumeHistory.shift();
          }
          if (this.closeHistory.length > POCKET_PIVOT_LOOKBACK + 1) {
            this.closeHistory.shift();
          }

          if (time) {
            const barDate = new Date(time * 1000);
            const sessionDateKey = barDate.toISOString().split('T')[0];
            
            if (this.currentSessionDate !== sessionDateKey) {
              if (this.currentSessionDate !== null && this.currentSessionVolume !== undefined && this.currentSessionClose !== null) {
                const prevSessionClose = this.sessionData.length > 0 
                  ? this.sessionData[this.sessionData.length - 1].close 
                  : null;
                
                this.sessionData.push({
                  date: this.currentSessionDate,
                  volume: this.currentSessionVolume,
                  close: this.currentSessionClose,
                  prevClose: prevSessionClose
                });
                
                if (this.sessionData.length > POCKET_PIVOT_LOOKBACK + 1) {
                  this.sessionData.shift();
                }
              }
              
              this.currentSessionDate = sessionDateKey;
              this.currentSessionVolume = 0;
            }
            
            this.currentSessionVolume = (this.currentSessionVolume || 0) + volume;
            this.currentSessionClose = close;
          }

          let volumeMA = 0;
          if (this.volumeHistory.length > 0) {
            const periodToUse = Math.min(maPeriod, this.volumeHistory.length);
            let sum = 0;
            const startIndex = Math.max(0, this.volumeHistory.length - periodToUse);
            for (let i = startIndex; i < this.volumeHistory.length; i++) {
              sum += this.volumeHistory[i];
            }
            volumeMA = sum / periodToUse;
          }
          
          const displayMA = maVisible ? volumeMA : null;

          let isPocketPivot = false;
          
          const prevSessionClose = this.sessionData.length > 0 
            ? this.sessionData[this.sessionData.length - 1].close 
            : (this.currentSessionPrevClose || prevClose);
          const isPriceRising = close > prevSessionClose;
          const currentSessionVolume = this.currentSessionVolume || 0;
          
          if (isPriceRising && this.sessionData && this.sessionData.length >= POCKET_PIVOT_LOOKBACK) {
            let maxDownDayVolume = 0;
            let foundDownDays = false;
            
            for (let i = 0; i < POCKET_PIVOT_LOOKBACK && i < this.sessionData.length; i++) {
              const sessionInfo = this.sessionData[this.sessionData.length - 1 - i];
              
              if (sessionInfo && sessionInfo.close !== null && sessionInfo.prevClose !== null) {
                const isDownDay = sessionInfo.close < sessionInfo.prevClose;
                
                if (isDownDay && sessionInfo.volume != null && sessionInfo.volume !== undefined && !isNaN(sessionInfo.volume) && sessionInfo.volume > 0) {
                  foundDownDays = true;
                  if (sessionInfo.volume > maxDownDayVolume) {
                    maxDownDayVolume = sessionInfo.volume;
                  }
                }
              }
            }
            
            if (foundDownDays && maxDownDayVolume > 0 && currentSessionVolume > maxDownDayVolume) {
              isPocketPivot = true;
            }
          }

          let colorIndex = 0;
          
          if (isPocketPivot) {
            colorIndex = 3;
          } else if (volumeMA > 0 && volume >= volumeMA) {
            colorIndex = close >= open ? 2 : 1;
          } else {
            colorIndex = 0;
          }

          return [volume, colorIndex, displayMA];
        };
      },
      
    },
  ]);
}

export { custom_indicators_getter };
